import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const VisaRedemptionModal = ({ isOpen, redemptions, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>{t('visa_redemption_modal_title')}</ModalHeader>
      <ModalBody>
        <p>{t('visa_redemption_modal_instructions')}</p>
        {redemptions.map((redemption, index) => (
          <p key={`${redemption.raNumber}-${index}`}>
            {redemption.merchantName ? `${redemption.merchantName} — ` : ''}
            <strong>{t('visa_redemption_modal_ra_number')}:</strong> {redemption.raNumber}
          </p>
        ))}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClose}>
          {t('visa_redemption_modal_continue')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default VisaRedemptionModal;
